import { gql } from '@apollo/client';

export * from './invoicePdf.query.generated';

export const INVOICE_PDF = gql`
  query invoicePdf($id: ID!) {
    invoicePdf(invoiceId: $id) {
      downloadUrl
    }
  }
`;
